export default __webpack_public_path__ + "static/media/Vote.34d2a11c.png";